import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const IonPageWrapper = styled(IonPage)`
  .MuiTableRow-head {
    border-bottom: 1px solid #ccc;
  }
`;
